<div
  fxLayout="row wrap"
  class="contact-container"
>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="contact"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="space-between center"
    >
      <div class="address-container">
        <address fxLayout="column" fxLayoutAlign="space-between start">
          <a
            [href]="'tel:' + agencyService.agency.phone"
            target="_blank"
            fxLayout="row"
            fxLayoutAlign="start center"
            appGaEvent
            eventCategory="contact"
            eventAction="click"
            eventLabel="phone_click"
          >
            <div fxLayout="row" fxLayoutAlign="center">
              <img src="/assets/icons/contact/phone_secondary.svg" alt="">
            </div>
            Director Vânzari
            {{ agencyService.agency.phone | beautify }}
          </a>
          <a
            href="tel:+40735189633"
            target="_blank"
            fxLayout="row"
            fxLayoutAlign="start center"
            appGaEvent
            eventCategory="contact"
            eventAction="click"
            eventLabel="phone_click"
          >
            <div fxLayout="row" fxLayoutAlign="center">
              <img src="/assets/icons/contact/phone_secondary.svg" alt="">
            </div>
            Reprezentant Vânzari
            0735 189 633
          </a>
          <a
            [href]="'https://maps.google.com?daddr='
            + agencyService.agency.latitude + ','
            + agencyService.agency.longitude + '&amp;ll='"
            target="_blank"
            fxLayout="row"
            fxLayoutAlign="start center"
            appGaEvent
            eventCategory="contact"
            eventAction="click"
            eventLabel="maps_click"
          >
            <div fxLayout="row" fxLayoutAlign="center">
              <img src="/assets/icons/contact/location_secondary.svg" alt="">
            </div>
            {{ agencyService.agency.address }}
          </a>
          <a
            [href]="'mailto:' + agencyService.agency.email"
            target="_blank"
            fxLayout="row"
            fxLayoutAlign="start center"
            appGaEvent
            eventCategory="contact"
            eventAction="click"
            eventLabel="email_click"
          >
            <div fxLayout="row" fxLayoutAlign="center">
              <img src="/assets/icons/contact/email_secondary.svg" alt="">
            </div>
            {{ agencyService.agency.email }}
          </a>
        </address>
      </div>
      <app-social-icons-base [isTooltipBelow]="false"></app-social-icons-base>
      <app-contact-form-base [title]="'Formular de contact'"></app-contact-form-base>
    </div>
  </div>
  <div class="google-map">
    <app-google-map-iframe
      [latitude]="agencyService.agency.latitude"
      [longitude]="agencyService.agency.longitude"
      [zoom]="15"
    >
    </app-google-map-iframe>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.html